<template>
<div>
   <div :class="loading ? 'white-page': ''">
      <PageInfo v-if="currentStep" :title="currentStep.title" :subTitle="currentStep.description" />
   </div>
   <div v-if="loading" class="page-loading">
      <i class="fas fa-circle-notch fa-6x fa-spin theme-calc"></i>
      <div class="loading-lable">Loading Page...</div>
   </div>
   <div class="user-info-error" v-if="this.error">
      <ApiError :error="error" @errorClicked="closeError" />
   </div>
   <div v-if="studentTypes" class="step-one row">
      <div class="col-12 col-lg-5 col-md-6">
         <DropDown
            :label="enrolmentTypes.label"
            :options="enTypes"
            @focus="displayInfo(enrolmentTypes.info)"
            @select="setEnrolment"
         />
         <DropDown
            :label="courseTypes.label"
            :options="coTypes"
            :override="coTypes.length === 1 ? coTypes[0] : ''"
            :disabled="this.enrolmentType ? false : true"
            @focus="displayInfo(courseTypes.info)"
            @select="setCourse"
         />
         <DropDown
            :label="feeTypes.label"
            :options="feTypes"
            :override="feTypes.length === 1 ? feTypes[0] : ''"
            :disabled="this.enrolmentType && this.courseType ? false : true"
            @focus="displayInfo(feeTypes.info)"
            @select="setFee"
         />
         <DropDown
            :label="commencementYears.label"
            :options="comYears"
            :override="comYears.length === 1 ? comYears[0] : ''"
            :disabled="this.enrolmentType && this.courseType && this.feeType ? false : true"
            @focus="displayInfo(commencementYears.info)"
            @select="setYears"
         />
         <NavButton
            type="primary"
            label="Select course and units"
            :disabled="this.studentID ? false : true"
            @goTo="$router.push({name:'course-options'})"
         />
      </div>
      <div class="col ml-lg-6 col-md-6">
         <transition name="fade" mode="out-in">
            <div :key="this.currentDisplay" class="current-info" v-html="this.currentDisplay" >
            </div>
         </transition>
      </div>
   </div>
</div>
</template>

<script>
   import PageInfo from './pageInfo.vue'
   import ApiError from 'client/components/murdoch/ApiError.vue'

   import { mapGetters, mapActions, mapState } from 'vuex'
   export default {
      components: { PageInfo, ApiError },
      data: function(){
         return {
            currentDisplay: "",
            studentTypes: null,
            loading: false,
            error: null,
         }
      },
      created: function(){
         this.loading = true;
         this.fetchStudentTypes().then(response =>{
            this.studentTypes = response.studentTypes;
         }).catch(err =>{
            this.error = err;
         }).finally(() =>{
            this.loading = false;
         })
      },
      mounted: function() {
         this.displayInfo(this.enrolmentTypes.info);
      },
      computed: {
         ...mapState({

            enrolmentTypes: state => state.global.enrolmentTypes,
            feeTypes: state => state.global.feeTypes,
            courseTypes: state => state.global.courseTypes,
            commencementYears: state => state.global.commencementYears,

            studentID: state => state.selections.studentID,
            enrolmentType: state => state.selections.enrolmentType,
            feeType: state => state.selections.feeType,
            courseType: state => state.selections.courseType,
            commencementYear: state => state.selections.commencementYear,

            selectedItems: state => state.selections.selectedItems,
         }),
         ...mapGetters({
            step: 'getStep',
            currentStep: 'getCurrentStep'
         }),
         enTypes: function(){
            return [...new Set(this.studentTypes.map(x => x.studentType))]
         },
         coTypes: function(){
            var f1 = this.studentTypes.filter(x =>
               x.studentType.includes(this.enrolmentType)
            )
            return [...new Set(f1.map(x => x.courseType))]
         },
         feTypes: function(){
            var f2 = this.studentTypes.filter(x =>
               x.studentType.includes(this.enrolmentType) &&
               x.courseType.includes(this.courseType)
            )
            return [...new Set(f2.map(x => x.feeType))]
         },
         comYears: function(){
            var f3 = this.studentTypes.filter(x =>
               x.studentType.includes(this.enrolmentType) &&
               x.courseType.includes(this.courseType) &&
               x.feeType.includes(this.feeType)
            )
            return [...new Set(f3.map(x => x.commencementYear))]
         },
      },
      methods: {
         ...mapActions([
            'setEnrolmentType',
            'setCourseType',
            'setStudentID',
            'setCommencementYear',
            'setFeeType',
            'enableStep',
            'disableStep',
            'fetchStudentTypes',
            'fetchFees',

         ]),
         displayInfo: function(data){
            this.currentDisplay = data;
         },
         setEnrolment: function(data){
            this.setEnrolmentType(data);
         },
         setCourse: function(data){
            this.setCourseType(data);
         },
         setFee: function(data){
            this.setFeeType(data);
         },
         setYears: function(data){
            this.setCommencementYear(data);
         },
         setstudentType: function(data){
            this.setStudentID(null);
            for(var i=0; i<this.studentTypes.length; i++){
               if(this.studentTypes[i].studentType === this.enrolmentType &&
               this.studentTypes[i].courseType === this.courseType &&
               this.studentTypes[i].feeType === this.feeType &&
               this.studentTypes[i].commencementYear === this.commencementYear){
                  this.setStudentID(this.studentTypes[i]);
                  this.fetchFees(this.studentID.studentTypeCode);
               }
            }
            if(this.studentID) {
               this.enableStep(2);
               if(this.selectedItems.length){
                  this.enableStep(3);
               }else{
                  this.disableStep(3)
               }
            }else{
               this.disableStep(2);
               this.disableStep(3);
            }
         },
         closeError: function(){
            this.loading = true;
            this.fetchStudentTypes().then(response =>{
               this.studentTypes = response.studentTypes;
            }).catch(err =>{
               this.error = err;
            }).finally(() =>{
               this.loading = false;
            })
         }
      },
      watch: {
         enrolmentType: function (val) {
            this.setstudentType()
         },
         courseType: function (val) {
            this.setstudentType()
         },
         feeType: function (val) {
            this.setstudentType()
         },
         commencementYear: function (val) {
            this.setstudentType()
         },
         selectedItems(){
            if(this.selectedItems.length){
               this.enableStep(3);
            }else{
               this.disableStep(3)
            }
         },
      }
   }
</script>

<style>
</style>
